import { eventsApiSlice } from '../../../../../store/eventApiSlice';

export const extendedApiSlice = eventsApiSlice
  .enhanceEndpoints({
    addTagTypes: ['EventsCalendar', 'EventBookings', 'dayDetails'],
  })
  .injectEndpoints({
    endpoints: (builder) => ({
      getEventsCalendar: builder.query({
        query: ({ month, year }) => ({
          url: `event-admin/calendar`,
          params: { month, year },
        }),
        providesTags: (result, error) =>
          error ? [] : [{ type: 'EventsCalendar' }],
      }),
      getEventBookings: builder.query({
        query: (id) => ({
          url: `event-admin/bookings/event/${id}`,
        }),
        providesTags: (result, error) =>
          error ? [] : [{ type: 'EventBookings' }],
      }),
      getDayView: builder.query({
        query: (date) => ({
          url: `event-admin/bookings/daily-participants/${date}`,
        }),
        providesTags: (result, error) =>
          error ? [] : [{ type: 'dayDetails' }],
      }),
      getEventBookingDetails: builder.mutation({
        query: (id) => ({
          url: `event-admin/bookings/${id}`,
        }),
        providesTags: (result, error) =>
          error ? [] : [{ type: 'EventBookingsDetails' }],
      }),
      deleteBooking: builder.mutation({
        query: (data) => ({
          url: `event-admin/bookings/${data}`,
          method: 'delete',
        }),
        invalidatesTags: (result, error) => [{ type: 'dayDetails' }],
      }),

      checkInParticipant: builder.mutation({
        query: ({ participant_id, checked_in }) => ({
          method: 'POST',
          url: `event-admin/bookings/check-in/${participant_id}?value=${checked_in}`,
        }),
        invalidatesTags: (result, error) => [
          { type: 'dayDetails' },
          { type: 'EventBookingsDetails' },
        ],
      }),
      getDashboardData: builder.query({
        query: ({ start, end }) => ({
          url: `event-admin/dashboard/statistics?start=${start}&end=${end}`,
        }),
      }),
      getEventAdminDetailedStatistics: builder.query({
        query: ({ start, end }) => ({
          url: `event-admin/dashboard/statistics-full?start=${start}&end=${end}`,
        }),
      }),
      getAwardOptions: builder.query({
        query: () => ({
          method: 'GET',
          url: `awards/schemes`,
        }),
      }),
      sendAward: builder.mutation({
        query: ({ participant_id, award_scheme_id }) => ({
          method: 'POST',
          url: `awards/admin/grant`,
          data: { participant_id, award_scheme_id },
        }),
        invalidatesTags: (result, error) => [
          { type: 'dayDetails' },
          { type: 'EventBookingsDetails' },
        ],
      }),
      updatePhotoConsent: builder.mutation({
        query: ({ participant_id, photo_consent }) => ({
          method: 'POST',
          url: `event-admin/bookings/photo-consent/${participant_id}?value=${photo_consent}`,
        }),
        invalidatesTags: (result, error) => [
          { type: 'dayDetails' },
          { type: 'EventBookingsDetails' },
        ],
      }),
    }),
  });

export const {
  useGetEventsCalendarQuery,
  useGetEventBookingsQuery,
  useGetEventBookingDetailsMutation,
  useGetDayViewQuery,
  useDeleteBookingMutation,
  useCheckInParticipantMutation,
  useGetDashboardDataQuery,
  useGetEventAdminDetailedStatisticsQuery,
  useGetAwardOptionsQuery,
  useSendAwardMutation,
  useUpdatePhotoConsentMutation,
} = extendedApiSlice;
